// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins", sans-serif !important;
  /* font-weight: 500; */
  color: #707070;
}
.primaryColor {
  color: #707070 !important;
}
.bgPrimary {
  background-color: #d18146 !important;
}
::-webkit-scrollbar {
  width: 2px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #954c0a;
}
::placeholder,
.ant-select-selection-placeholder {
  color: #707070 !important;
  opacity: 1;
  /* font-weight: 500; */
}
:-ms-input-placeholder {
  color: #707070 !important;
}
::-ms-input-placeholder {
  color: #707070 !important;
}
.mb-30 {
  margin-bottom: 30px;
}
.mr-5 {
  margin-right: 5px;
}
.ml-0 {
  margin-left: 0 !important;
}
.mt-10 {
  margin-top: 100px;
}
.greenText {
  color: #22b253 !important;
}
.uploadText {
  color: #5b5b5b !important;
  font-weight: 500;
}
/* .ant-modal-mask {
  background: transparent !important;
} */
.ant-menu-submenu-arrow,
.ant-drawer-header-no-title .ant-drawer-close {
  color: #fff !important;
}
.ant-input-search .ant-input:focus,
.ant-select:focus {
  border-color: transparent !important;
  box-shadow: none !important;
  border-right-width: 0px !important;
  outline: 0 !important;
}
.brandText {
  border-left: 2px solid #212529;
  margin-left: 10px;
  padding-left: 15px;
  color: #707070;
  font-weight: 400;
}
.timeSection {
  margin-bottom: 0 !important;
}
/* .timeSection .ant-form-item-control-input-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
} */
.langSwitcher {
  margin-right: 5rem;
}
.langIcon {
  font-size: 18px;
  line-height: 18px;
  color: #707070;
  margin-right: 10px;
}
.langName {
  color: #707070;
}
.table-responsive {
  border-radius: 16px;
}
/***** SignIn Page Style *****/
.signInPage {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: right 35% bottom 45% !important;
}
.signInPage .assetsSection img {
  width: 339px;
}
.signInPage .ant-form-item {
  margin-bottom: 15px;
}
.signInPage .SignInFormSection .customCard {
  border-radius: 14px;
  width: 401px;
  margin: 0 auto;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
}
.signInPage .SignInFormSection .customCard .ant-card-body {
  padding: 55px 66px;
}
.signInPage .SignInFormSection .customCard .customFormControl,
.accordionSection .customFormControl {
  border: 1px solid #e4e4e4 !important;
  border-radius: 6px !important;
  height: 50px !important;
  padding: 10px 20px !important;
}
.customFormControl {
  border: 1px solid #e4e4e4 !important;
  border-radius: 6px !important;
  height: 50px !important;
  padding: 10px 20px !important;
}
.h-100 {
  height: auto !important;
}
.customFormControl .ant-input-group {
  border: 1px solid #e4e4e4 !important;
  border-radius: 6px !important;
  height: 50px !important;
  padding: 10px 20px !important;
}
.signInPage .SignInFormSection .customCard .ant-input-prefix {
  margin-right: 20px;
  color: #bcbcbc;
}
.login-form-forgot {
  color: #707070;
  font-weight: 500;
}
.signInForm .ant-checkbox + span {
  color: #707070;
}
.customButton {
  width: 100% !important;
  background-color: #f6851f !important;
  border-color: #f6851f !important;
  border-radius: 22px !important;
  height: 43px !important;
}
.customButtonOutlined {
  width: 100% !important;
  color: #f6851f !important;
  background-color: #fff !important;
  border-color: #f6851f !important;
  border-radius: 22px !important;
  height: 43px !important;
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #22b253 !important;
  border-color: #22b253 !important;
  border-radius: 2px !important;
}
.orText {
  text-align: center;
  margin-bottom: 0;
  color: #707070;
}
.addProductForm .ant-form-item {
  margin-bottom: 10px;
}
.borderRadius textarea {
  border-radius: 6px !important;
  border: 1px solid #e4e4e4 !important;
}
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 98px;
  background: #d18146;
  z-index: 99;
  transition: all 0.5s ease;
}
.sidebar .logo-details #btn {
  position: absolute;
  top: 50%;
  /* right: 0; */
  transform: translateY(-50%);
  font-size: 22px;
  transition: all 0.4s ease;
  font-size: 23px;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
}
.sidebar .logo-details {
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #954c0a;
}
.sidebar .menuImg {
  color: #fff;
  height: 35px;
  min-width: 35px;
  text-align: center;
  line-height: 35px;
}
.sidebar .nav-list {
  /* margin-top: 20px; */
  height: 100%;
  padding-left: 0;
  background: transparent;
}
.sidebar li {
  position: relative !important;
  margin: 0 !important;
  /* margin: 15px 8px !important; */
  list-style: none;
}
.sidebar li a {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 0px;
  /* padding: 8px; */
  border-radius: 0px;
  align-items: center;
  text-decoration: none;
  transition: 0.2s linear;
}
/* .sidebar li a:hover {
  background: #954c0a;
} */
.active {
  background: #954c0a;
  border-radius: 0px;
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.sidebar li a:hover .links_name {
  transition: all 0.5s ease;
  color: #fff;
}
.sidebar li a:hover .menuImg {
  transition: all 0.5s ease;
  color: #11101d;
}
.sidebar li a .links_name {
  width: 100%;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: 0.4s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sidebar li .menuImg {
  width: 35px;
  height: 35px;
  line-height: 35px !important;
  border-radius: 50%;
  background-color: #fff;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
}
.sidebar li .profile-details {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.sidebar.open {
  width: 314px;
}
.sidebar.open .logo-details .icon {
  opacity: 1;
}
.sidebar.open .logo-details .logo_name {
  opacity: 1;
}
.sidebar.open .logo-details #btn {
  text-align: right;
}
.sidebar.open li a .links_name {
  opacity: 1;
  pointer-events: auto;
}
.sidebar.open ~ .home-section {
  left: 314px;
  width: calc(100% - 314px);
}
.sidebar.open ~ .home-section .contentSection .timlineSection .w-30 {
  left: 66rem;
  /* width: calc(100% - 27%); */
  transition: all 0.5s ease;
}
.sidebar.open .logo-details #btn {
  left: 1.8rem;
}
.home-section {
  position: relative;
  background: #f3f3f3;
  min-height: 100vh;
  top: 0;
  left: 90px;
  width: calc(100% - 90px);
  transition: all 0.5s ease;
  z-index: 2;
}
.custom-navbar {
  height: 62px;
  padding-top: 0;
  padding-bottom: 0;
  position: sticky;
  top: 0;
  z-index: 9999;
}
.custom-navbar .navbar-collapse {
  justify-content: end;
}
.contentSection {
  padding: 5px 25px;
}
.pageHeader h2 {
  font-size: 18px !important;
  font-weight: 500 !important;
}
.reportHeader h2 {
  font-size: 18px !important;
  color: #707070 !important;
}
.master_heading {
  color: #707070 !important;
  letter-spacing: 1px;
}
.accordionSection .ant-collapse-header {
  background-color: #ef790d;
  padding: 0px !important;
  border-top-right-radius: 14px !important;
  border-top-left-radius: 14px !important;
  color: #fff !important;
  font-size: 16px !important;
  overflow: hidden;
}
.accordionSection
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  font-size: 16px !important;
  font-weight: 500 !important;
  float: right;
  margin-top: 50%;
  margin-right: 0px;
  background: #ef790d;
  padding: 18px;
}
.accordionSection .ant-collapse-content-box {
  padding: 0px !important;
}
.accordionSection .ant-collapse-borderless > .ant-collapse-item:last-child,
.accordionSection .ant-collapse {
  border-bottom-right-radius: 14px !important;
  border-bottom-left-radius: 14px !important;
  border-color: transparent;
}
.accordionSection
  .ant-col
  .ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  height: 50px;
  padding: 10px 20px;
}
.accordionSection .ant-form-item {
  display: block !important;
}
.accordionSection .ant-form-item-label > label::after {
  display: none !important;
}
.site-collapse-title {
  width: 20%;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 0 !important;
  padding: 11px 20px;
}
/***** Custom Card Style *****/
.customCard {
  border-radius: 14px !important;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
/* .customCard:hover {
  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.2);
} */
.customCard .ant-card-body {
  padding: 14px 24px;
}
.imgCir {
  width: 45px;
  height: 45px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card1Bg {
  background: #ef790d;
}
.card2Bg {
  background: #e6a827;
}
.card3Bg {
  background: #a8bcc1;
}
.card4Bg {
  background: #f44336;
}
.card5Bg {
  background: #5baf25;
}
.innerCon .textSec .cardHeading h5 {
  font-size: 14px;
}
.innerCon .counterText h4 {
  font-size: 44px !important;
  font-weight: 300 !important;
  margin-bottom: 0 !important;
  color: #f6851f !important;
}
.cardActive {
  border: 1px solid #ef790d;
}
/***** sellerRegistration Style *****/
.formHeading h5 {
  font-size: 18px !important;
  color: #707070 !important;
  font-weight: 400 !important;
}
.formHeading p {
  color: #707070;
  line-height: 30px;
}
.sellerRegistration .formSection .formBody {
  padding: 30px 0 0px 50px;
}
.sellerRegistration .formSection .bottomContent p {
  font-size: 11px;
  color: #707070;
  margin-bottom: 0.2rem;
  text-align: center;
}
.ant-btn.stepButton {
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  color: #fff;
  border: 1px solid #d18146;
  background: #d18146;
  margin: 0 auto;
  transition: all 0.4s ease-in-out;
}
.ant-btn.stepButton:hover {
  border: 1px solid #d18146;
  background: #fff;
  color: #d18146;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);
}
.ant-btn.stepButton:focus {
  border: 1px solid #d18146;
  background: #fff;
  color: #d18146;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);
}
.formSections {
  width: 100%;
  height: 100%;
  padding-top: 25px;
  padding-bottom: 25px;
}
.formSections .ant-form-item,
.formSections .ant-form-item .ant-checkbox-wrapper p,
.formHeading p {
  margin-bottom: 5px;
}

.ant-form-item:has(.ant-select) .ant-form-item-explain-error {
  margin-top: 14px;
}

.ant-layout,
.ant-layout-content {
  background: #f5f5f5;
}

.ant-card,
.ant-table {
  border-radius: 12px;
}

.ant-table-container {
  border-radius: 12px;
  overflow: hidden;
}

.ant-table-thead > tr > th {
  padding: 12px 16px !important;
  font-size: 13px;
  font-weight: 600;
  vertical-align: middle;
  white-space: nowrap;
}

/* Sort icon spacing */
.ant-table-column-sorters {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ant-collapse-header {
  background: #f97316;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
}

.ant-collapse-content {
  border-radius: 0 0 10px 10px;
}

.ant-collapse-header {
  background: #f97316;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
}

.ant-collapse-content {
  border-radius: 0 0 10px 10px;
}
/***** Step ****/
.stepSection {
  background: #fff;
  padding: 60px 19px;
  height: 93vh;
}
.stepSection .ant-steps-item-title {
  font-size: 12px;
  color: #707070;
}
.stepSection .ant-steps-item-icon {
  width: 21px;
  height: 21px;
  line-height: 21px;
  font-size: 12px;
}
.stepSection
  .ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-icon {
  background: #22b253;
}
.stepSection .ant-steps-item-process .ant-steps-item-icon {
  border-color: #22b253;
  box-shadow: 0px 0px 3px 3px rgb(34 178 83 / 50%) !important;
}
.stepSection .ant-steps-vertical > .ant-steps-item {
  height: 65px;
}
.stepSection
  .ant-steps-vertical
  > .ant-steps-item
  > .ant-steps-item-container
  > .ant-steps-item-tail {
  padding: 21px 0 0px;
  left: 10px;
}
.stepSection
  .ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-tail::after {
  background-color: #bcbcbc;
}
.stepSection .ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
  line-height: 21px;
  font-weight: 500;
}
.sellerFormDes .customFormControl,
.sellerFormDes
  .ant-col
  .ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  width: 100%;
  height: 44px;
  background: #fff;
  border-radius: 6px;
  border-color: #fff;
}
.sellerFormDes
  .ant-col
  .ant-select:not(.ant-select-customize-input)
  .ant-select-selector,
.PhoneInput {
  padding: 5px 11px;
}
.sellerFormDes .PhoneInput input {
  border: 0;
}
.sellerFormDes .PhoneInput input:focus {
  border: 0;
  outline: 0;
  box-shadow: none;
}
.PhoneInputCountrySelectArrow {
  display: none !important;
}
.customButtonOutlinedDraft {
  width: 150px !important;
  color: #f6851f !important;
  background-color: transparent !important;
  border-color: #f6851f !important;
  border-radius: 22px !important;
  height: 43px !important;
  transition: all 0.3s ease-in-out;
}
.customButtonOutlinedDraft:hover {
  width: 150px !important;
  color: #fff !important;
  background-color: #f6851f !important;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);
}
.customButtonOutlinedBoard,
.warehouseModal .ant-modal-footer .ant-btn {
  width: auto !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #f6851f !important;
  background-color: #fff !important;
  border-color: #f6851f !important;
  border-radius: 22px !important;
  height: 30px !important;
  transition: all 0.5s ease-in-out;
  text-shadow: none !important;
  margin-bottom: 10px;
}
.customButtonOutlinedBoard:hover,
.warehouseModal .ant-modal-footer .ant-btn:hover {
  width: auto !important;
  color: #fff !important;
  background-color: #f6851f !important;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);
}
.customButtonBoard,
.warehouseModal .ant-modal-footer .ant-btn-primary {
  width: auto !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #fff !important;
  background-color: #f6851f !important;
  border-color: #f6851f !important;
  border-radius: 22px !important;
  height: 30px !important;
  transition: all 0.5s ease-in-out;
  text-shadow: none !important;
}
.customButtonBoard:hover,
.warehouseModal .ant-modal-footer .ant-btn-primary:hover {
  width: auto !important;
  color: #f6851f !important;
  background-color: #fff !important;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);
}
.largeNumber {
  font-size: 500px;
  opacity: 40%;
  position: absolute;
  top: -7rem;
  right: 0;
  font-weight: 900;
  color: #fff;
  line-height: 500px;
  z-index: -1;
}
.uploadBtn label {
  font-size: 12px !important;
  font-weight: 600;
  color: #707070 !important;
  margin-right: 5px;
}
.uploadBtn label::after {
  display: none;
}
/* .uploadBtn .ant-upload-list-text {
  position: absolute;
  right: 6.3rem;
  top: 2.5rem;
} */
.docUploadBtn {
  background-color: #f6851f !important;
  border-color: #f6851f !important;
  border-radius: 32px !important;
  color: #fff !important;
  height: 25px !important;
  padding: 2px !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  width: 90px !important;
  display: flex !important;
  /* justify-content: space-between; */
  /* align-items: center; */
}
.upImg {
  background: #fff;
  border-radius: 50%;
  width: 19px;
  height: 19px;
  line-height: 19px;
  margin-right: 15px;
}
.infoText {
  font-size: 10px;
  font-weight: 600;
  color: #707070;
  display: flex;
  align-items: center;
}
.addBtnMore {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: #707070 !important;
}
.addMoreBtn span.anticon.anticon-plus {
  color: #22b253 !important;
  font-size: 20px !important;
  margin-right: 15px !important;
  font-weight: 600 !important;
}
.stepSectionContent {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height: 88vh; */
  min-height: calc(91vh - 0px);
  justify-content: space-between;
}
.slctLabel label {
  width: 100% !important;
  display: block !important;
  white-space: normal;
  text-align: left;
  height: auto !important;
  margin-bottom: 20px;
  color: #707070 !important;
}
label:after {
  display: none;
}
.ant-row.ant-form-item.slctLabel {
  flex-direction: column !important;
}
.steps-action {
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 35px;
}
.ant-steps-vertical
  > .ant-steps-item
  > .ant-steps-item-container
  > .ant-steps-item-tail::after {
  width: 2px !important;
}
.ant-steps-item-finish
  > .ant-steps-item-container
  > .ant-steps-item-tail::after {
  background-color: #22b253 !important;
}
.ant-steps-item-finish .ant-steps-item-icon {
  background-color: #22b253 !important;
  border-color: #22b253 !important;
  box-shadow: 0px 0px 3px 3px rgb(34 178 83 / 50%) !important;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #ffffff !important;
  top: -5px !important;
}
.addMoreBtn {
  font-size: 18px;
  color: #22b253;
  margin-right: 10px;
}
.customTab .ant-tabs > .ant-tabs-nav,
.ant-tabs > div > .ant-tabs-nav,
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
.customTab .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,
.customTab .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap,
.customTab .ant-tabs-tab {
  width: 100% !important;
}
.customTab .ant-tabs-tab {
  display: block !important;
  text-align: center;
}
.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #707070 !important;
  font-weight: 400 !important;
}
.ant-tabs-tab {
  font-size: 16px !important;
  color: #707070 !important;
}
.ant-tabs-ink-bar {
  background: #f6851f !important;
}
.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
  height: 7px !important;
  border-radius: 50px !important;
}
.ant-tabs-top > .ant-tabs-nav::before,
.ant-tabs-top > div > .ant-tabs-nav::before {
  border-bottom-color: #bcbcbc !important;
  bottom: 6px !important;
}
.customModal .ant-modal-content {
  background-color: #954c0a !important;
  color: #fff !important;
  border-radius: 14px !important;
}
.customModal .ant-modal-footer {
  display: none;
}
.customModal .ant-modal-close {
  top: -1rem !important;
  right: -3rem;
}
.customModal .ant-modal-close .ant-modal-close-x {
  color: #fff !important;
}
.customModal .ant-modal-body {
  padding: 38px 43px !important;
}
.thnkMsg {
  font-size: 20px;
}
.sub-menu ul li a {
  color: #fff !important;
}
.ant-menu-submenu-popup .ant-menu-sub {
  background-color: #954c0a !important;
}
.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {
  border-bottom: 1px solid #f9f9f9;
  margin: 0 !important;
}
.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item:last-child {
  border-bottom: 0;
}
.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item .ant-menu-title-content a {
  color: #fff;
}
.customConfirmModal .ant-modal-content {
  background-color: transparent !important;
  box-shadow: none !important;
}
.customConfirmModal .card {
  width: 100%;
  border: none;
  height: 350px;
  box-shadow: 0px 5px 10px 0px rgb(193 193 193 / 50%);
  z-index: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 14px;
}
.customConfirmModal .card h6 {
  color: #707070;
  font-size: 20px;
}
.customConfirmModal .inputs input {
  width: 40px;
  height: 40px;
}
.customConfirmModal .ant-modal-close-x {
  display: none;
}
.flex-fill {
  flex: 1 1 auto;
}
.customConfirmModal input[type="number"]::-webkit-inner-spin-button,
.customConfirmModal input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.customConfirmModal .card-2 {
  background-color: #fff;
  padding: 10px;
  width: 80%;
  height: 100px;
  bottom: -55px;
  left: 0;
  right: 0;
  position: absolute;
  border-radius: 14px;
  margin: 0 auto;
}

.card-2 .content {
  margin-top: 50px;
}

.card-2 .content a {
  color: #f6851f;
}

.form-control:focus {
  box-shadow: none;
  border: 2px solid #f6851f;
}

.validate {
  border-radius: 20px;
  height: 40px;
  background-color: #f6851f;
  border: 1px solid #f6851f;
  width: 140px;
}
.select-before {
  width: 90px;
}
[data-theme="compact"] .select-before {
  width: 71px;
}
/***** Custom Side Menu *****/
.customSideMenu {
  background: transparent !important;
  overflow-y: auto;
  height: calc(100% - 70px);
}
.customSideMenu.ant-menu-vertical {
  border-right: 0;
}
.customSideMenu.ant-menu-vertical > .ant-menu-item {
  line-height: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ffffff85;
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.customSideMenu.ant-menu-vertical > .ant-menu-item > * {
  text-align: center !important;
}
.customSideMenu.ant-menu-vertical > .ant-menu-item .ant-menu-title-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.customSideMenu .ant-menu-sub.ant-menu-inline {
  background: transparent !important;
}
.customSideMenu .ant-menu-title-content,
.customSideMenu .ant-menu-title-content a {
  color: #fff !important;
  font-size: 12px !important;
  font-weight: 500;
  text-align: center !important;
  white-space: normal;
  line-height: 16px !important;
  margin: 0 auto !important;
  width: 100% !important;
  display: block !important;
  text-align: center !important;
}
.customSideMenu > .ant-menu-item > .ant-menu-title-content,
.customSideMenu > .ant-menu-item > .ant-menu-title-content > a {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin: 0 auto !important;
  padding: 0 !important;
  text-align: center !important;
}
.customSideMenu > .ant-menu-item .ant-menu-title-content {
  text-align: center !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.customSideMenu > .ant-menu-item .ant-menu-title-content a {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin: 0 auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: center !important;
}
.customSideMenu > .ant-menu-submenu {
  padding-bottom: 0px !important;
}
/* .customSideMenu > .ant-menu-submenu li a:hover {
  background: none !important;
  color: #954c0a;
} */
.customSideMenu > .ant-menu-submenu > .ant-menu-submenu-title,
.customSideMenu > .ant-menu-item {
  padding: 8px !important;
  height: auto !important;
  left: 0px !important;
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.customSideMenu > .ant-menu-submenu > .ant-menu-submenu-title:hover,
.customSideMenu > .ant-menu-item:hover {
  background: #954c0a;
  border-radius: 0px;
  /* border-radius: 6px; */
  transition: all 0.3s ease-in-out;
}
.ant-menu-item .ant-menu-item-icon + span {
  margin-left: 0px !important;
}
.customSideMenu.ant-menu-inline {
  border-right: 0 !important;
}
.customSideMenu.ant-menu-inline .ant-menu-item {
  width: 100% !important;
  margin-right: 0 !important;
  box-sizing: border-box;
}
.menuIconImg {
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: block;
}
.menuImg {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {
  display: flex;
}

/* ===============================
   AntD v5 Menu Active + Hover FIX
   =============================== */

/* DEFAULT menu text */
.ant-menu-item,
.ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-item {
  color: #ffffff !important;
}

/* HOVER (non-selected only) */
.ant-menu-item:not(.ant-menu-item-selected):hover,
.ant-menu-submenu-title:hover,
.ant-menu-submenu-popup .ant-menu-item:not(.ant-menu-item-selected):hover {
  background-color: #6e3500 !important;
}

/* SELECTED item (ALWAYS visible) */
.ant-menu-item-selected {
  color: #ffffff !important;
  background-color: #6e3500 !important; /* dark active */
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}

/* SELECTED + HOVER (keep active look) */
.ant-menu-item-selected:hover {
  color: #ffffff !important;
  background-color: #6e3500 !important;
}

/* PARENT submenu when child selected */
.ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: #ffffff !important;
  background-color: #6e3500 !important;
}

/* Selected menu item background */
.ant-menu-item-selected {
  background-color: #7ebe3d !important; /* dark brown */
  color: #ffffff !important;
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}

/* Selected submenu item */
.ant-menu-submenu-popup .ant-menu-item-selected {
  background-color: #6e3500 !important;
  color: #ffffff !important;
}

/* Remove AntD default blue indicator */
.ant-menu-item-selected::after {
  border-right: none !important;
}

.customSubMenu > .ant-menu-submenu-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 !important;
}
.customSubMenu {
  border-bottom: 1px solid #ffffff85;
  color: white;
}

.customSideMenu > .ant-menu-submenu > .ant-menu-submenu-title,
.customSubMenu > .ant-menu-submenu > .ant-menu-submenu-title,
.customSideMenu > .ant-menu-item {
  padding: 8px !important;
  height: auto !important;
  left: 0px !important;
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}

.customSubMenu > .ant-menu-submenu-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 !important;
}

.customSubMenu > .ant-menu-submenu-title .ant-menu-item-icon + span {
  margin-left: 0px !important;
}
.customSubMenu > .ant-menu-submenu-title .ant-menu-item-icon + span {
  margin-left: 0px !important;
}
.sidebar .customSideMenu > li {
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.sidebar .customSideMenu > li > .ant-menu-item,
.sidebar .customSideMenu > li > .ant-menu-submenu > .ant-menu-submenu-title {
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.sidebar .customSideMenu > li > div > .ant-menu-submenu-arrow {
  opacity: 0;
  color: #fff;
}
.sidebar.open .customSideMenu > li > div > .ant-menu-submenu-arrow {
  opacity: 1;
  color: #fff;
  transition: all 0.1s;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #6e3500 !important;
  border-radius: 0px !important;
  margin-right: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.ant-menu-inline .ant-menu-item::after {
  display: none !important;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item {
  left: 5px !important;
}
.ant-menu-inline {
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: hidden;
}
/* .ant-menu-title-content a:hover {
  color: #000 !important
} */
.ant-tooltip-inner {
  background: #fff !important;
  padding: 10px 15px !important;
}
.ant-tooltip-inner a {
  color: rgba(0, 0, 0, 0.85) !important;
}
.ant-tooltip-arrow {
  display: none !important;
}
.ant-tooltip-placement-right {
  padding-left: 0 !important;
}
.formItem {
  margin-bottom: 25px !important;
  margin-left: 0 !important;
}
.customPhoneNumber .ant-input-group-addon {
  height: 44px;
  border: 0;
  background: #fff;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.customPhoneNumber .ant-input {
  height: 44px;
  border: 0;
  background: #fff;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.sideFixed {
  position: fixed !important;
  width: 100%;
  right: 0;
}
.sellerFormDes {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(83vh - 0px);
  justify-content: space-between;
}

/***** Custom Table *****/
.stateCustomTable .ant-table {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}
.stateCustomTable table thead .ant-table-cell,
.lotCustomTable thead tr .ant-table-cell {
  background: #ef790d !important;
  color: #fff !important;
  text-transform: uppercase;
  font-weight: 500 !important;
  padding: 10px;
}
.stateCustomTable table tbody .ant-table-cell {
  padding: 10px !important;
  font-weight: 500;
}
.textCenter table tbody .ant-table-cell,
.textCenter table thead .ant-table-cell {
  text-align: center;
  padding: 13px !important;
  font-weight: 500;
  font-size: 12px;
}
table tbody .ant-table-cell,
table thead .ant-table-cell {
  font-size: 12px;
}
.stateCustomTable table thead .ant-table-cell,
.stateCustomTable table tbody .ant-table-cell {
  text-align: center;
}
.stateCustomTable table thead .ant-table-cell::before {
  display: none !important;
}
.stateCustomTable .ant-pagination,
.reportCustomtable .ant-pagination {
  background: #fff !important;
  margin: 0 !important;
  padding: 10px 50px !important;
  justify-content: end !important;
  border-bottom-left-radius: 14px !important;
  border-bottom-right-radius: 14px !important;
}
.stateCustomTable
  .ant-pagination
  .ant-pagination-prev
  .ant-pagination-item-link,
.reportCustomtable
  .ant-pagination
  .ant-pagination-prev
  .ant-pagination-item-link,
.stateCustomTable
  .ant-pagination
  .ant-pagination-next
  .ant-pagination-item-link,
.reportCustomtable
  .ant-pagination
  .ant-pagination-next
  .ant-pagination-item-link {
  background-color: transparent !important;
  color: #bcbcbc !important;
  font-size: 14px !important;
  line-height: 14px !important;
  border: 0 !important;
}
.stateCustomTable .ant-pagination .ant-pagination-item-active,
.reportCustomtable .ant-pagination .ant-pagination-item-active {
  border-color: #fff !important;
  border-radius: 50% !important;
  background-color: #f3f3f3 !important;
  color: #707070 !important;
}
.stateCustomTable table > thead > tr:first-child th:first-child {
  border-top-left-radius: 14px !important;
}
.stateCustomTable table > thead > tr:last-child th:last-child {
  border-top-right-radius: 14px !important;
}
.stateCustomTable table > tbody > tr:nth-child(even) {
  background-color: #f9f9f9 !important;
}
.stateCustomTable .ant-table-column-sorters,
.reportCustomtable .ant-table-column-sorters {
  justify-content: center !important;
}
.stateCustomTable .ant-table-column-title,
.reportCustomtable .ant-table-column-title {
  flex: initial !important;
}
.stateCustomTable .ant-table-column-sorter,
.reportCustomtable .ant-table-column-sorter {
  color: #fff !important;
  margin-left: 10px;
}
.stateCustomTable .anticon {
  font-size: 14px;
  color: #fff !important;
  /* margin-right: 10px; */
}
.stateCustomTable
  table
  tbody
  .ant-table-expanded-row
  .ant-table-cell
  table
  thead
  .ant-table-cell {
  background: #ededed !important;
  color: inherit !important;
  text-transform: inherit;
  font-weight: inherit !important;
}
.nastedTable table > thead > tr:first-child th:first-child,
.nastedTable table > thead > tr:last-child th:last-child {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.nastedTable table thead .ant-table-cell,
.nastedTable table tbody .ant-table-cell {
  text-align: center;
}
.reportCustomtable table thead .ant-table-cell {
  background: #954c0a !important;
  color: #fff !important;
  text-transform: uppercase;
  font-weight: 500 !important;
  padding: 10px !important;
}
.stateCustomTable
  .ant-pagination
  .ant-pagination-prev
  .ant-pagination-item-link,
.stateCustomTable
  .ant-pagination
  .ant-pagination-next
  .ant-pagination-item-link,
.deltaTable .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
.deltaTable .ant-pagination .ant-pagination-next .ant-pagination-item-link {
  background-color: transparent !important;
  color: #000 !important;
  font-size: 16px !important;
  line-height: 16px !important;
}
.stateCustomTable .ant-pagination .ant-pagination-item,
.deltaTable .ant-pagination .ant-pagination-item {
  border-color: #fff !important;
  border-radius: 50% !important;
}
.stateCustomTable .ant-pagination .ant-pagination-item-active,
.deltaTable .ant-pagination .ant-pagination-item-active {
  border-color: #ef790c !important;
  background: #ef790c !important;
  color: #fff !important;
}
.stateCustomTable .ant-pagination,
.deltaTable .ant-pagination {
  background: #dcdcdc !important;
  margin: 0 !important;
  padding: 16px 0 !important;
  justify-content: center !important;
  border-bottom-left-radius: 14px !important;
  border-bottom-right-radius: 14px !important;
}
.greenBoxs {
  display: flex;
  justify-content: end;
}
.greenBoxs .innerGreenBox {
  width: 130px;
  text-align: center;
  background: #22b253;
  margin-left: 2px;
}
.greenBoxs .innerGreenBox p {
  margin-bottom: 0;
  color: #fff;
}
.greenBoxs .innerGreenBox .boxDesc {
  font-size: 18px;
  font-weight: 600;
}
.math {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.invoiceBtn {
  background: transparent !important;
  border: 0 !important;
  color: #707070 !important;
  font-size: 16px !important;
  box-shadow: none !important;
}
.invoiceBtn:hover {
  background: transparent;
  color: #954c0a !important;
}
/***** Filter Section *****/
.filterSection {
  display: flex;
  justify-content: end;
  align-items: center;
}
.customSearch .ant-input-group .ant-input-group-addon {
  box-shadow: none !important;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}
.customSearch .ant-input-group .ant-input-group-addon .ant-input-search-button {
  background: #22b253 !important;
  border-color: #22b253 !important;
  box-shadow: none !important;
  padding: 5px 10px;
  border-top-right-radius: 25px !important;
  border-bottom-right-radius: 25px !important;
}
.customInput .ant-select-selector,
.customInput .ant-input-affix-wrapper {
  border: 0 !important;
  height: 32px;
  font-size: 12px !important;
  border-radius: 25px !important;
  font-weight: 500;
}
/* .font-md .ant-select-selector, .font-md .ant-input-affix-wrapper {
  font-size: 14px !important;
  font-weight: 500;
} */
.ant-select-dropdown {
  padding: 0 !important;
}
.ant-select-dropdown .ant-select-item {
  font-size: 12px;
  padding: 8px !important;
  border-bottom: 1px solid #f3f3f3;
}
/***** FormModal *****/
.ant-popover .ant-popover-content .ant-popover-inner {
  border-radius: 6px !important;
  box-shadow: 0px 0px 6px 5px rgba(0, 0, 0, 0.1);
}
.ant-popover
  .ant-popover-content
  .ant-popover-inner
  .ant-popover-inner-content {
  padding: 0;
}
.editFormProduct .ant-form-item {
  padding: 5px 20px;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 5px;
}
.editFormProduct .ant-form-item:first-child {
  padding: 15px 15px 0 15px;
}
.editFormProduct .ant-form-item:last-child {
  padding: 15px 25px;
  text-align: end;
}
.editFormProduct .ant-form-item .ant-form-item-label {
  padding-bottom: 0 !important;
}
.editFormProduct .ant-form-item .ant-form-item-control-input {
  min-height: 0 !important;
}
.editFormProduct .ant-form-item .ant-form-item-control-input input {
  font-size: 12px;
  border: 0;
  padding: 0;
}
.editFormProduct .ant-form-item .ant-form-item-label label {
  color: #bcbcbc;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
}
.dragBox .ant-upload-drag {
  border: 2px dashed #bcbcbc !important;
  border-radius: 6px !important;
  padding: 10px;
}
.dragBox .ant-form-item-control-input-content > p + span {
  display: flex;
  justify-content: space-between;
}
/* .dragBox .ant-form-item-control-input-content > p + span .ant-upload-drag,
.dragBox .ant-form-item-control-input-content > p + span .ant-upload-list-text {
  width: 50%;
  padding: 0 15px;
} */
.dragBox .ant-upload.ant-upload-drag p.ant-upload-text {
  font-size: 14px;
}
.infoTexts {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.infoTexts .anticon {
  font-size: 24px;
  color: #bcbcbc;
  margin-right: 10px;
}
.divider {
  width: 100%;
  height: 1px;
  background: #f6851f;
  margin: 10px 0;
}
.underLogoText {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 500;
}
.prefixImg .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
  border: 1px solid #e4e4e4 !important;
  border-radius: 6px !important;
  height: 50px !important;
  padding: 10px 20px !important;
  background-color: #fff;
}
input:focus {
  box-shadow: none !important;
  outline: 0 !important;
  border-color: transparent !important;
}

.colAfter::after {
  position: absolute;
  content: ">";
  font-size: 26px;
  color: #22b253;
  top: 30%;
  right: -7px;
  bottom: 0;
}
.tableInput {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between;
  align-items: center; */
}
/***** Warehouse Modal *****/
.warehouseModal .ant-modal-content {
  border-radius: 20px;
}
.warehouseModal .ant-modal-content .ant-modal-header {
  background: #954c0a;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.warehouseModal .ant-modal-content .ant-modal-header .ant-modal-title {
  color: #fff;
}
.warehouseModal .ant-modal-content .ant-modal-close {
  background: #fff;
  top: 10px;
  right: 10px;
  border-radius: 10px;
}
.warehouseModal .ant-modal-content .ant-modal-close .ant-modal-close-x {
  width: 30px;
  height: 30px;
  line-height: 24px;
}
.warehouseModal .ant-modal-body p {
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9e9e9;
}
.warehouseModal .ant-modal-body p:last-child {
  border-bottom: none;
}
.valueImage {
  width: 60px;
  height: 60px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
/**** Profile Dropdown *****/
.profileDropdownMenu {
  padding: 0 !important;
}
.profileDropdownMenu .ant-dropdown-menu-item {
  padding: 10px 12px;
  border-bottom: 1px solid #e9e9e9;
  color: #000 !important;
  font-weight: 500;
}
.profileDropdownMenu .ant-dropdown-menu-item .dropMenuIcon {
  margin-right: 10px;
  color: #954c0a;
  font-size: 16px;
  vertical-align: text-top;
}
.editButton {
  font-size: 16px;
  color: #707070 !important;
  font-weight: 500;
}
.editButton:hover {
  color: #954c0a !important;
}
.absltBtn {
  position: absolute !important;
  width: auto !important;
  color: #fff !important;
  top: 1.5rem;
}
.absltBtn span {
  font-size: 14px;
}

.deltaTableHeader {
  width: 100%;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ef790c;
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}
.deltaTableHeader .innerGreenBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  margin-right: 10px;
  padding: 10px 15px;
  cursor: pointer;
}
.deltaTableHeader .innerGreenBox .boxHeading {
  margin-right: 15px;
}
.deltaTableHeader .innerGreenBox .boxHeading,
.deltaTableHeader .innerGreenBox .boxDesc {
  font-size: 16px;
  color: #707070;
  margin-bottom: 0px;
  text-transform: uppercase;
}
.sllrPrdctBtn {
  top: 1.2rem;
  right: 19rem;
}
/***** Responsive Style *****/
@media (max-width: 280px) {
  .signInPage .SignInFormSection .customCard .ant-card-body {
    padding: 14px 24px;
  }
}
@media (max-width: 767px) {
  .mobHide {
    display: none !important;
  }
  .signInPage .SignInFormSection .customCard {
    width: 100%;
  }
  .sellerRegistration .formSection .formBody {
    padding-left: 0;
  }
  .mobCenter {
    margin: 0 auto;
  }
  .sideFixed {
    display: none;
  }
  .formSections {
    padding-bottom: 50px;
  }
  .sidebar,
  .sidebar.open {
    display: none;
  }
  .home-section,
  .sidebar.open ~ .home-section {
    width: 100%;
    left: 0;
  }
  .mobSider .sidebar,
  .mobSider .sidebar.open {
    display: block;
    width: auto;
  }
  .mobSider .ant-drawer-content-wrapper {
    width: 80% !important;
  }
  .mobSider .ant-drawer-body {
    padding: 10px !important;
  }
  .mobSider.ant-drawer .ant-drawer-content {
    background: #d18146;
  }
  .mobSider .nav-list {
    /* margin-top: 20px; */
    height: 100%;
    padding-left: 0;
    background: transparent;
  }
  .mobSider ul li .menuImg {
    width: 35px;
    height: 35px;
    line-height: 35px;
    border-radius: 50%;
    background-color: #fff;
    text-align: center;
  }
  .mobSider li {
    position: relative !important;
    margin: 15px 8px !important;
    list-style: none;
  }
  .mobSider li a {
    display: flex;
    height: 100%;
    width: 100%;
    padding: 8px;
    border-radius: 6px;
    align-items: center;
    text-decoration: none;
    transition: 0.2s linear;
    -webkit-transition: 0.2s linear;
    -moz-transition: 0.2s linear;
    -ms-transition: 0.2s linear;
    -o-transition: 0.2s linear;
  }
  .table-responsive .ant-table-content {
    overflow-x: auto;
  }
  .tabDirection,
  .filterSection {
    flex-direction: column;
  }
  .filterSection .customInput {
    width: 100% !important;
    margin-bottom: 15px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .signInPage .SignInFormSection .customCard {
    width: 100%;
  }
  .signInPage .SignInFormSection .customCard .ant-card-body {
    padding: 25px;
  }
  .sidebar,
  .sidebar.open {
    display: none;
  }
  .home-section,
  .sidebar.open ~ .home-section {
    width: 100%;
    left: 0;
  }
  .mobSider .sidebar,
  .mobSider .sidebar.open {
    display: block;
    width: auto;
  }
  .mobSider .ant-drawer-content-wrapper {
    width: 50% !important;
  }
  .mobSider .ant-drawer-body {
    padding: 10px !important;
  }
  .mobSider.ant-drawer .ant-drawer-content {
    background: #d18146;
  }
  .mobSider .nav-list {
    /* margin-top: 20px; */
    height: 100%;
    padding-left: 0;
    background: transparent;
  }
  .mobSider ul li .menuImg {
    width: 35px;
    height: 35px;
    line-height: 35px;
    border-radius: 50%;
    background-color: #fff;
    text-align: center;
  }
  .mobSider li {
    position: relative !important;
    margin: 15px 8px !important;
    list-style: none;
  }
  .mobSider li a {
    display: flex;
    height: 100%;
    width: 100%;
    padding: 8px;
    border-radius: 6px;
    align-items: center;
    text-decoration: none;
    transition: 0.2s linear;
    -webkit-transition: 0.2s linear;
    -moz-transition: 0.2s linear;
    -ms-transition: 0.2s linear;
    -o-transition: 0.2s linear;
  }
  .table-responsive .ant-table-content {
    overflow-x: auto;
  }
  .tabDirection {
    flex-direction: column;
  }
  .sellerRegistration .formSection .formBody {
    padding: 30px 0 0px 20px;
  }
}
@media only screen and (min-width: 64.063em) {
  /* .marTp {
    margin-top: 10%;
  } */
}
@media only screen and (min-width: 1400px) and (max-width: 2560px) {
  .lg-mb {
    margin-top: 22px !important;
  }
}

.ant-result {
  align-self: center;
}

body,
#root {
  height: 100%;
}

.errorPageBody {
  height: 100%;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;GAEG;AACH;;EAEE,sBAAsB;AACxB;AACA;;EAEE,oCAAoC;EACpC,2BAA2B;EAC3B,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;;;;GAIG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EAGd,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EAKrB,uBAAuB;AACzB;AACA;;GAEG;AACH;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,MAAM;EACN,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,wCAAwC;EACxC,uCAAuC;EACvC,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;;;;EAKE,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA,8BAA8B;AAC9B;EACE,8BAA8B;EAG9B,gDAAgD;EAChD,eAAe;EACf,gCAAgC;AAClC;AACA;;;;GAIG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EAGd,gDAAgD;AAClD;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EAGd,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;AACA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,2DAA2D;AAC7D;AACA;EACE,YAAY;AACd;AACA;;;;;EAKE,mBAAmB;EACnB,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EAGpC,gDAAgD;AAClD;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EAGpC,gDAAgD;AAClD;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EAGjC,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;;;;GAIG;AACH;EACE,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;EAGE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2DAA2D;AAC7D;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;;;;;;EAME,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;;EAEE,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mDAAmD;EACnD,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,aAAa;EACb,aAAa;EACb,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;;;GAGG;AACH;;EAEE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;;oCAEoC;;AAEpC,sBAAsB;AACtB;;;EAGE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;;EAGE,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,oCAAoC,EAAE,gBAAgB;EACtD,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC,EAAE,eAAe;EACrD,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;;;EAGE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;GAEG;AACH;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,6BAA6B;EAC7B,+BAA+B;EAC/B,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;;;;;;;;;;;;;;;;EAgBE,wCAAwC;EACxC,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;;;;;;;;EAQE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;;EAEE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;;;;;;;;;;EAUE,wCAAwC;EACxC,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;;EAEE,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,iBAAiB;EACjB,wCAAwC;EACxC,2CAA2C;AAC7C;AACA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;;GAGG;AACH;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gCAAgC;AAClC;AACA,sBAAsB;AACtB;EACE,6BAA6B;EAG7B,8CAA8C;AAChD;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;;;;GAIG;AACH;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,QAAQ;EACR,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB;wBACsB;AACxB;AACA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,6BAA6B;AAC7B;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,WAAW;IACX,OAAO;EACT;EACA;;IAEE,cAAc;IACd,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,WAAW;IACX,OAAO;EACT;EACA;;IAEE,cAAc;IACd,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;;KAEG;AACL;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["body {\n  font-family: \"Poppins\", sans-serif !important;\n  /* font-weight: 500; */\n  color: #707070;\n}\n.primaryColor {\n  color: #707070 !important;\n}\n.bgPrimary {\n  background-color: #d18146 !important;\n}\n::-webkit-scrollbar {\n  width: 2px;\n  height: 10px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: #954c0a;\n}\n::placeholder,\n.ant-select-selection-placeholder {\n  color: #707070 !important;\n  opacity: 1;\n  /* font-weight: 500; */\n}\n:-ms-input-placeholder {\n  color: #707070 !important;\n}\n::-ms-input-placeholder {\n  color: #707070 !important;\n}\n.mb-30 {\n  margin-bottom: 30px;\n}\n.mr-5 {\n  margin-right: 5px;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.mt-10 {\n  margin-top: 100px;\n}\n.greenText {\n  color: #22b253 !important;\n}\n.uploadText {\n  color: #5b5b5b !important;\n  font-weight: 500;\n}\n/* .ant-modal-mask {\n  background: transparent !important;\n} */\n.ant-menu-submenu-arrow,\n.ant-drawer-header-no-title .ant-drawer-close {\n  color: #fff !important;\n}\n.ant-input-search .ant-input:focus,\n.ant-select:focus {\n  border-color: transparent !important;\n  box-shadow: none !important;\n  border-right-width: 0px !important;\n  outline: 0 !important;\n}\n.brandText {\n  border-left: 2px solid #212529;\n  margin-left: 10px;\n  padding-left: 15px;\n  color: #707070;\n  font-weight: 400;\n}\n.timeSection {\n  margin-bottom: 0 !important;\n}\n/* .timeSection .ant-form-item-control-input-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n} */\n.langSwitcher {\n  margin-right: 5rem;\n}\n.langIcon {\n  font-size: 18px;\n  line-height: 18px;\n  color: #707070;\n  margin-right: 10px;\n}\n.langName {\n  color: #707070;\n}\n.table-responsive {\n  border-radius: 16px;\n}\n/***** SignIn Page Style *****/\n.signInPage {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-position: right 35% bottom 45% !important;\n}\n.signInPage .assetsSection img {\n  width: 339px;\n}\n.signInPage .ant-form-item {\n  margin-bottom: 15px;\n}\n.signInPage .SignInFormSection .customCard {\n  border-radius: 14px;\n  width: 401px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);\n}\n.signInPage .SignInFormSection .customCard .ant-card-body {\n  padding: 55px 66px;\n}\n.signInPage .SignInFormSection .customCard .customFormControl,\n.accordionSection .customFormControl {\n  border: 1px solid #e4e4e4 !important;\n  border-radius: 6px !important;\n  height: 50px !important;\n  padding: 10px 20px !important;\n}\n.customFormControl {\n  border: 1px solid #e4e4e4 !important;\n  border-radius: 6px !important;\n  height: 50px !important;\n  padding: 10px 20px !important;\n}\n.h-100 {\n  height: auto !important;\n}\n.customFormControl .ant-input-group {\n  border: 1px solid #e4e4e4 !important;\n  border-radius: 6px !important;\n  height: 50px !important;\n  padding: 10px 20px !important;\n}\n.signInPage .SignInFormSection .customCard .ant-input-prefix {\n  margin-right: 20px;\n  color: #bcbcbc;\n}\n.login-form-forgot {\n  color: #707070;\n  font-weight: 500;\n}\n.signInForm .ant-checkbox + span {\n  color: #707070;\n}\n.customButton {\n  width: 100% !important;\n  background-color: #f6851f !important;\n  border-color: #f6851f !important;\n  border-radius: 22px !important;\n  height: 43px !important;\n}\n.customButtonOutlined {\n  width: 100% !important;\n  color: #f6851f !important;\n  background-color: #fff !important;\n  border-color: #f6851f !important;\n  border-radius: 22px !important;\n  height: 43px !important;\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #22b253 !important;\n  border-color: #22b253 !important;\n  border-radius: 2px !important;\n}\n.orText {\n  text-align: center;\n  margin-bottom: 0;\n  color: #707070;\n}\n.addProductForm .ant-form-item {\n  margin-bottom: 10px;\n}\n.borderRadius textarea {\n  border-radius: 6px !important;\n  border: 1px solid #e4e4e4 !important;\n}\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 98px;\n  background: #d18146;\n  z-index: 99;\n  transition: all 0.5s ease;\n}\n.sidebar .logo-details #btn {\n  position: absolute;\n  top: 50%;\n  /* right: 0; */\n  transform: translateY(-50%);\n  font-size: 22px;\n  transition: all 0.4s ease;\n  font-size: 23px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.5s ease;\n}\n.sidebar .logo-details {\n  height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background-color: #954c0a;\n}\n.sidebar .menuImg {\n  color: #fff;\n  height: 35px;\n  min-width: 35px;\n  text-align: center;\n  line-height: 35px;\n}\n.sidebar .nav-list {\n  /* margin-top: 20px; */\n  height: 100%;\n  padding-left: 0;\n  background: transparent;\n}\n.sidebar li {\n  position: relative !important;\n  margin: 0 !important;\n  /* margin: 15px 8px !important; */\n  list-style: none;\n}\n.sidebar li a {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  padding: 0px;\n  /* padding: 8px; */\n  border-radius: 0px;\n  align-items: center;\n  text-decoration: none;\n  -webkit-transition: 0.2s linear;\n  -moz-transition: 0.2s linear;\n  -ms-transition: 0.2s linear;\n  -o-transition: 0.2s linear;\n  transition: 0.2s linear;\n}\n/* .sidebar li a:hover {\n  background: #954c0a;\n} */\n.active {\n  background: #954c0a;\n  border-radius: 0px;\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n.sidebar li a:hover .links_name {\n  transition: all 0.5s ease;\n  color: #fff;\n}\n.sidebar li a:hover .menuImg {\n  transition: all 0.5s ease;\n  color: #11101d;\n}\n.sidebar li a .links_name {\n  width: 100%;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.4s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.sidebar li .menuImg {\n  width: 35px;\n  height: 35px;\n  line-height: 35px !important;\n  border-radius: 50%;\n  background-color: #fff;\n  margin-left: 5px;\n  margin-right: 5px;\n  margin-bottom: 10px;\n}\n.sidebar li .profile-details {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n.sidebar.open {\n  width: 314px;\n}\n.sidebar.open .logo-details .icon {\n  opacity: 1;\n}\n.sidebar.open .logo-details .logo_name {\n  opacity: 1;\n}\n.sidebar.open .logo-details #btn {\n  text-align: right;\n}\n.sidebar.open li a .links_name {\n  opacity: 1;\n  pointer-events: auto;\n}\n.sidebar.open ~ .home-section {\n  left: 314px;\n  width: calc(100% - 314px);\n}\n.sidebar.open ~ .home-section .contentSection .timlineSection .w-30 {\n  left: 66rem;\n  /* width: calc(100% - 27%); */\n  transition: all 0.5s ease;\n}\n.sidebar.open .logo-details #btn {\n  left: 1.8rem;\n}\n.home-section {\n  position: relative;\n  background: #f3f3f3;\n  min-height: 100vh;\n  top: 0;\n  left: 90px;\n  width: calc(100% - 90px);\n  transition: all 0.5s ease;\n  z-index: 2;\n}\n.custom-navbar {\n  height: 62px;\n  padding-top: 0;\n  padding-bottom: 0;\n  position: sticky;\n  top: 0;\n  z-index: 9999;\n}\n.custom-navbar .navbar-collapse {\n  justify-content: end;\n}\n.contentSection {\n  padding: 5px 25px;\n}\n.pageHeader h2 {\n  font-size: 18px !important;\n  font-weight: 500 !important;\n}\n.reportHeader h2 {\n  font-size: 18px !important;\n  color: #707070 !important;\n}\n.master_heading {\n  color: #707070 !important;\n  letter-spacing: 1px;\n}\n.accordionSection .ant-collapse-header {\n  background-color: #ef790d;\n  padding: 0px !important;\n  border-top-right-radius: 14px !important;\n  border-top-left-radius: 14px !important;\n  color: #fff !important;\n  font-size: 16px !important;\n  overflow: hidden;\n}\n.accordionSection\n  .ant-collapse\n  > .ant-collapse-item\n  > .ant-collapse-header\n  .ant-collapse-arrow {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  float: right;\n  margin-top: 50%;\n  margin-right: 0px;\n  background: #ef790d;\n  padding: 18px;\n}\n.accordionSection .ant-collapse-content-box {\n  padding: 0px !important;\n}\n.accordionSection .ant-collapse-borderless > .ant-collapse-item:last-child,\n.accordionSection .ant-collapse {\n  border-bottom-right-radius: 14px !important;\n  border-bottom-left-radius: 14px !important;\n  border-color: transparent;\n}\n.accordionSection\n  .ant-col\n  .ant-select:not(.ant-select-customize-input)\n  .ant-select-selector {\n  border: 1px solid #e4e4e4;\n  border-radius: 6px;\n  height: 50px;\n  padding: 10px 20px;\n}\n.accordionSection .ant-form-item {\n  display: block !important;\n}\n.accordionSection .ant-form-item-label > label::after {\n  display: none !important;\n}\n.site-collapse-title {\n  width: 20%;\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 0 !important;\n  padding: 11px 20px;\n}\n/***** Custom Card Style *****/\n.customCard {\n  border-radius: 14px !important;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n/* .customCard:hover {\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.2);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.2);\n} */\n.customCard .ant-card-body {\n  padding: 14px 24px;\n}\n.imgCir {\n  width: 45px;\n  height: 45px;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.card1Bg {\n  background: #ef790d;\n}\n.card2Bg {\n  background: #e6a827;\n}\n.card3Bg {\n  background: #a8bcc1;\n}\n.card4Bg {\n  background: #f44336;\n}\n.card5Bg {\n  background: #5baf25;\n}\n.innerCon .textSec .cardHeading h5 {\n  font-size: 14px;\n}\n.innerCon .counterText h4 {\n  font-size: 44px !important;\n  font-weight: 300 !important;\n  margin-bottom: 0 !important;\n  color: #f6851f !important;\n}\n.cardActive {\n  border: 1px solid #ef790d;\n}\n/***** sellerRegistration Style *****/\n.formHeading h5 {\n  font-size: 18px !important;\n  color: #707070 !important;\n  font-weight: 400 !important;\n}\n.formHeading p {\n  color: #707070;\n  line-height: 30px;\n}\n.sellerRegistration .formSection .formBody {\n  padding: 30px 0 0px 50px;\n}\n.sellerRegistration .formSection .bottomContent p {\n  font-size: 11px;\n  color: #707070;\n  margin-bottom: 0.2rem;\n  text-align: center;\n}\n.ant-btn.stepButton {\n  width: 42px;\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  color: #fff;\n  border: 1px solid #d18146;\n  background: #d18146;\n  margin: 0 auto;\n  transition: all 0.4s ease-in-out;\n}\n.ant-btn.stepButton:hover {\n  border: 1px solid #d18146;\n  background: #fff;\n  color: #d18146;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n}\n.ant-btn.stepButton:focus {\n  border: 1px solid #d18146;\n  background: #fff;\n  color: #d18146;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n}\n.formSections {\n  width: 100%;\n  height: 100%;\n  padding-top: 25px;\n  padding-bottom: 25px;\n}\n.formSections .ant-form-item,\n.formSections .ant-form-item .ant-checkbox-wrapper p,\n.formHeading p {\n  margin-bottom: 5px;\n}\n\n.ant-form-item:has(.ant-select) .ant-form-item-explain-error {\n  margin-top: 14px;\n}\n\n.ant-layout,\n.ant-layout-content {\n  background: #f5f5f5;\n}\n\n.ant-card,\n.ant-table {\n  border-radius: 12px;\n}\n\n.ant-table-container {\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.ant-table-thead > tr > th {\n  padding: 12px 16px !important;\n  font-size: 13px;\n  font-weight: 600;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n/* Sort icon spacing */\n.ant-table-column-sorters {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ant-collapse-header {\n  background: #f97316;\n  color: #fff;\n  font-weight: 600;\n  border-radius: 10px;\n}\n\n.ant-collapse-content {\n  border-radius: 0 0 10px 10px;\n}\n\n.ant-collapse-header {\n  background: #f97316;\n  color: #fff;\n  font-weight: 600;\n  border-radius: 10px;\n}\n\n.ant-collapse-content {\n  border-radius: 0 0 10px 10px;\n}\n/***** Step ****/\n.stepSection {\n  background: #fff;\n  padding: 60px 19px;\n  height: 93vh;\n}\n.stepSection .ant-steps-item-title {\n  font-size: 12px;\n  color: #707070;\n}\n.stepSection .ant-steps-item-icon {\n  width: 21px;\n  height: 21px;\n  line-height: 21px;\n  font-size: 12px;\n}\n.stepSection\n  .ant-steps-item-process\n  > .ant-steps-item-container\n  > .ant-steps-item-icon {\n  background: #22b253;\n}\n.stepSection .ant-steps-item-process .ant-steps-item-icon {\n  border-color: #22b253;\n  box-shadow: 0px 0px 3px 3px rgb(34 178 83 / 50%) !important;\n}\n.stepSection .ant-steps-vertical > .ant-steps-item {\n  height: 65px;\n}\n.stepSection\n  .ant-steps-vertical\n  > .ant-steps-item\n  > .ant-steps-item-container\n  > .ant-steps-item-tail {\n  padding: 21px 0 0px;\n  left: 10px;\n}\n.stepSection\n  .ant-steps-item-process\n  > .ant-steps-item-container\n  > .ant-steps-item-tail::after {\n  background-color: #bcbcbc;\n}\n.stepSection .ant-steps-vertical > .ant-steps-item .ant-steps-item-title {\n  line-height: 21px;\n  font-weight: 500;\n}\n.sellerFormDes .customFormControl,\n.sellerFormDes\n  .ant-col\n  .ant-select:not(.ant-select-customize-input)\n  .ant-select-selector {\n  width: 100%;\n  height: 44px;\n  background: #fff;\n  border-radius: 6px;\n  border-color: #fff;\n}\n.sellerFormDes\n  .ant-col\n  .ant-select:not(.ant-select-customize-input)\n  .ant-select-selector,\n.PhoneInput {\n  padding: 5px 11px;\n}\n.sellerFormDes .PhoneInput input {\n  border: 0;\n}\n.sellerFormDes .PhoneInput input:focus {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n}\n.PhoneInputCountrySelectArrow {\n  display: none !important;\n}\n.customButtonOutlinedDraft {\n  width: 150px !important;\n  color: #f6851f !important;\n  background-color: transparent !important;\n  border-color: #f6851f !important;\n  border-radius: 22px !important;\n  height: 43px !important;\n  transition: all 0.3s ease-in-out;\n}\n.customButtonOutlinedDraft:hover {\n  width: 150px !important;\n  color: #fff !important;\n  background-color: #f6851f !important;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n}\n.customButtonOutlinedBoard,\n.warehouseModal .ant-modal-footer .ant-btn {\n  width: auto !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  color: #f6851f !important;\n  background-color: #fff !important;\n  border-color: #f6851f !important;\n  border-radius: 22px !important;\n  height: 30px !important;\n  transition: all 0.5s ease-in-out;\n  text-shadow: none !important;\n  margin-bottom: 10px;\n}\n.customButtonOutlinedBoard:hover,\n.warehouseModal .ant-modal-footer .ant-btn:hover {\n  width: auto !important;\n  color: #fff !important;\n  background-color: #f6851f !important;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n}\n.customButtonBoard,\n.warehouseModal .ant-modal-footer .ant-btn-primary {\n  width: auto !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  color: #fff !important;\n  background-color: #f6851f !important;\n  border-color: #f6851f !important;\n  border-radius: 22px !important;\n  height: 30px !important;\n  transition: all 0.5s ease-in-out;\n  text-shadow: none !important;\n}\n.customButtonBoard:hover,\n.warehouseModal .ant-modal-footer .ant-btn-primary:hover {\n  width: auto !important;\n  color: #f6851f !important;\n  background-color: #fff !important;\n  -webkit-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  -moz-box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.01);\n}\n.largeNumber {\n  font-size: 500px;\n  opacity: 40%;\n  position: absolute;\n  top: -7rem;\n  right: 0;\n  font-weight: 900;\n  color: #fff;\n  line-height: 500px;\n  z-index: -1;\n}\n.uploadBtn label {\n  font-size: 12px !important;\n  font-weight: 600;\n  color: #707070 !important;\n  margin-right: 5px;\n}\n.uploadBtn label::after {\n  display: none;\n}\n/* .uploadBtn .ant-upload-list-text {\n  position: absolute;\n  right: 6.3rem;\n  top: 2.5rem;\n} */\n.docUploadBtn {\n  background-color: #f6851f !important;\n  border-color: #f6851f !important;\n  border-radius: 32px !important;\n  color: #fff !important;\n  height: 25px !important;\n  padding: 2px !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  width: 90px !important;\n  display: flex !important;\n  /* justify-content: space-between; */\n  /* align-items: center; */\n}\n.upImg {\n  background: #fff;\n  border-radius: 50%;\n  width: 19px;\n  height: 19px;\n  line-height: 19px;\n  margin-right: 15px;\n}\n.infoText {\n  font-size: 10px;\n  font-weight: 600;\n  color: #707070;\n  display: flex;\n  align-items: center;\n}\n.addBtnMore {\n  background: transparent !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  color: #707070 !important;\n}\n.addMoreBtn span.anticon.anticon-plus {\n  color: #22b253 !important;\n  font-size: 20px !important;\n  margin-right: 15px !important;\n  font-weight: 600 !important;\n}\n.stepSectionContent {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  /* height: 88vh; */\n  min-height: calc(91vh - 0px);\n  justify-content: space-between;\n}\n.slctLabel label {\n  width: 100% !important;\n  display: block !important;\n  white-space: normal;\n  text-align: left;\n  height: auto !important;\n  margin-bottom: 20px;\n  color: #707070 !important;\n}\nlabel:after {\n  display: none;\n}\n.ant-row.ant-form-item.slctLabel {\n  flex-direction: column !important;\n}\n.steps-action {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding: 0 35px;\n}\n.ant-steps-vertical\n  > .ant-steps-item\n  > .ant-steps-item-container\n  > .ant-steps-item-tail::after {\n  width: 2px !important;\n}\n.ant-steps-item-finish\n  > .ant-steps-item-container\n  > .ant-steps-item-tail::after {\n  background-color: #22b253 !important;\n}\n.ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #22b253 !important;\n  border-color: #22b253 !important;\n  box-shadow: 0px 0px 3px 3px rgb(34 178 83 / 50%) !important;\n}\n.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: #ffffff !important;\n  top: -5px !important;\n}\n.addMoreBtn {\n  font-size: 18px;\n  color: #22b253;\n  margin-right: 10px;\n}\n.customTab .ant-tabs > .ant-tabs-nav,\n.ant-tabs > div > .ant-tabs-nav,\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,\n.customTab .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,\n.customTab .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap,\n.customTab .ant-tabs-tab {\n  width: 100% !important;\n}\n.customTab .ant-tabs-tab {\n  display: block !important;\n  text-align: center;\n}\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #707070 !important;\n  font-weight: 400 !important;\n}\n.ant-tabs-tab {\n  font-size: 16px !important;\n  color: #707070 !important;\n}\n.ant-tabs-ink-bar {\n  background: #f6851f !important;\n}\n.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {\n  height: 7px !important;\n  border-radius: 50px !important;\n}\n.ant-tabs-top > .ant-tabs-nav::before,\n.ant-tabs-top > div > .ant-tabs-nav::before {\n  border-bottom-color: #bcbcbc !important;\n  bottom: 6px !important;\n}\n.customModal .ant-modal-content {\n  background-color: #954c0a !important;\n  color: #fff !important;\n  border-radius: 14px !important;\n}\n.customModal .ant-modal-footer {\n  display: none;\n}\n.customModal .ant-modal-close {\n  top: -1rem !important;\n  right: -3rem;\n}\n.customModal .ant-modal-close .ant-modal-close-x {\n  color: #fff !important;\n}\n.customModal .ant-modal-body {\n  padding: 38px 43px !important;\n}\n.thnkMsg {\n  font-size: 20px;\n}\n.sub-menu ul li a {\n  color: #fff !important;\n}\n.ant-menu-submenu-popup .ant-menu-sub {\n  background-color: #954c0a !important;\n}\n.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {\n  border-bottom: 1px solid #f9f9f9;\n  margin: 0 !important;\n}\n.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item:last-child {\n  border-bottom: 0;\n}\n.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item .ant-menu-title-content a {\n  color: #fff;\n}\n.customConfirmModal .ant-modal-content {\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n.customConfirmModal .card {\n  width: 100%;\n  border: none;\n  height: 350px;\n  box-shadow: 0px 5px 10px 0px rgb(193 193 193 / 50%);\n  z-index: 1;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  border-radius: 14px;\n}\n.customConfirmModal .card h6 {\n  color: #707070;\n  font-size: 20px;\n}\n.customConfirmModal .inputs input {\n  width: 40px;\n  height: 40px;\n}\n.customConfirmModal .ant-modal-close-x {\n  display: none;\n}\n.flex-fill {\n  flex: 1 1 auto;\n}\n.customConfirmModal input[type=\"number\"]::-webkit-inner-spin-button,\n.customConfirmModal input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.customConfirmModal .card-2 {\n  background-color: #fff;\n  padding: 10px;\n  width: 80%;\n  height: 100px;\n  bottom: -55px;\n  left: 0;\n  right: 0;\n  position: absolute;\n  border-radius: 14px;\n  margin: 0 auto;\n}\n\n.card-2 .content {\n  margin-top: 50px;\n}\n\n.card-2 .content a {\n  color: #f6851f;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  border: 2px solid #f6851f;\n}\n\n.validate {\n  border-radius: 20px;\n  height: 40px;\n  background-color: #f6851f;\n  border: 1px solid #f6851f;\n  width: 140px;\n}\n.select-before {\n  width: 90px;\n}\n[data-theme=\"compact\"] .select-before {\n  width: 71px;\n}\n/***** Custom Side Menu *****/\n.customSideMenu {\n  background: transparent !important;\n  overflow-y: auto;\n  height: calc(100% - 70px);\n}\n.customSideMenu.ant-menu-vertical {\n  border-right: 0;\n}\n.customSideMenu.ant-menu-vertical > .ant-menu-item {\n  line-height: 0 !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #ffffff85;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n.customSideMenu.ant-menu-vertical > .ant-menu-item > * {\n  text-align: center !important;\n}\n.customSideMenu.ant-menu-vertical > .ant-menu-item .ant-menu-title-content {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.customSideMenu .ant-menu-sub.ant-menu-inline {\n  background: transparent !important;\n}\n.customSideMenu .ant-menu-title-content,\n.customSideMenu .ant-menu-title-content a {\n  color: #fff !important;\n  font-size: 12px !important;\n  font-weight: 500;\n  text-align: center !important;\n  white-space: normal;\n  line-height: 16px !important;\n  margin: 0 auto !important;\n  width: 100% !important;\n  display: block !important;\n  text-align: center !important;\n}\n.customSideMenu > .ant-menu-item > .ant-menu-title-content,\n.customSideMenu > .ant-menu-item > .ant-menu-title-content > a {\n  text-align: center !important;\n  display: block !important;\n  width: 100% !important;\n  margin: 0 auto !important;\n  padding: 0 !important;\n  text-align: center !important;\n}\n.customSideMenu > .ant-menu-item .ant-menu-title-content {\n  text-align: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100% !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.customSideMenu > .ant-menu-item .ant-menu-title-content a {\n  text-align: center !important;\n  display: block !important;\n  width: 100% !important;\n  margin: 0 auto !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  text-align: center !important;\n}\n.customSideMenu > .ant-menu-submenu {\n  padding-bottom: 0px !important;\n}\n/* .customSideMenu > .ant-menu-submenu li a:hover {\n  background: none !important;\n  color: #954c0a;\n} */\n.customSideMenu > .ant-menu-submenu > .ant-menu-submenu-title,\n.customSideMenu > .ant-menu-item {\n  padding: 8px !important;\n  height: auto !important;\n  left: 0px !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n.customSideMenu > .ant-menu-submenu > .ant-menu-submenu-title:hover,\n.customSideMenu > .ant-menu-item:hover {\n  background: #954c0a;\n  border-radius: 0px;\n  /* border-radius: 6px; */\n  transition: all 0.3s ease-in-out;\n}\n.ant-menu-item .ant-menu-item-icon + span {\n  margin-left: 0px !important;\n}\n.customSideMenu.ant-menu-inline {\n  border-right: 0 !important;\n}\n.customSideMenu.ant-menu-inline .ant-menu-item {\n  width: 100% !important;\n  margin-right: 0 !important;\n  box-sizing: border-box;\n}\n.menuIconImg {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  display: block;\n}\n.menuImg {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {\n  display: flex;\n}\n\n/* ===============================\n   AntD v5 Menu Active + Hover FIX\n   =============================== */\n\n/* DEFAULT menu text */\n.ant-menu-item,\n.ant-menu-submenu-title,\n.ant-menu-submenu-popup .ant-menu-item {\n  color: #ffffff !important;\n}\n\n/* HOVER (non-selected only) */\n.ant-menu-item:not(.ant-menu-item-selected):hover,\n.ant-menu-submenu-title:hover,\n.ant-menu-submenu-popup .ant-menu-item:not(.ant-menu-item-selected):hover {\n  background-color: #6e3500 !important;\n}\n\n/* SELECTED item (ALWAYS visible) */\n.ant-menu-item-selected {\n  color: #ffffff !important;\n  background-color: #6e3500 !important; /* dark active */\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n/* SELECTED + HOVER (keep active look) */\n.ant-menu-item-selected:hover {\n  color: #ffffff !important;\n  background-color: #6e3500 !important;\n}\n\n/* PARENT submenu when child selected */\n.ant-menu-submenu-selected > .ant-menu-submenu-title {\n  color: #ffffff !important;\n  background-color: #6e3500 !important;\n}\n\n/* Selected menu item background */\n.ant-menu-item-selected {\n  background-color: #7ebe3d !important; /* dark brown */\n  color: #ffffff !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n/* Selected submenu item */\n.ant-menu-submenu-popup .ant-menu-item-selected {\n  background-color: #6e3500 !important;\n  color: #ffffff !important;\n}\n\n/* Remove AntD default blue indicator */\n.ant-menu-item-selected::after {\n  border-right: none !important;\n}\n\n.customSubMenu > .ant-menu-submenu-title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 !important;\n}\n.customSubMenu {\n  border-bottom: 1px solid #ffffff85;\n  color: white;\n}\n\n.customSideMenu > .ant-menu-submenu > .ant-menu-submenu-title,\n.customSubMenu > .ant-menu-submenu > .ant-menu-submenu-title,\n.customSideMenu > .ant-menu-item {\n  padding: 8px !important;\n  height: auto !important;\n  left: 0px !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n.customSubMenu > .ant-menu-submenu-title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 !important;\n}\n\n.customSubMenu > .ant-menu-submenu-title .ant-menu-item-icon + span {\n  margin-left: 0px !important;\n}\n.customSubMenu > .ant-menu-submenu-title .ant-menu-item-icon + span {\n  margin-left: 0px !important;\n}\n.sidebar .customSideMenu > li {\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n.sidebar .customSideMenu > li > .ant-menu-item,\n.sidebar .customSideMenu > li > .ant-menu-submenu > .ant-menu-submenu-title {\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n.sidebar .customSideMenu > li > div > .ant-menu-submenu-arrow {\n  opacity: 0;\n  color: #fff;\n}\n.sidebar.open .customSideMenu > li > div > .ant-menu-submenu-arrow {\n  opacity: 1;\n  color: #fff;\n  transition: all 0.1s;\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #6e3500 !important;\n  border-radius: 0px !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n.ant-menu-inline .ant-menu-item::after {\n  display: none !important;\n}\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-item {\n  left: 5px !important;\n}\n.ant-menu-inline {\n  height: calc(100% - 80px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n/* .ant-menu-title-content a:hover {\n  color: #000 !important\n} */\n.ant-tooltip-inner {\n  background: #fff !important;\n  padding: 10px 15px !important;\n}\n.ant-tooltip-inner a {\n  color: rgba(0, 0, 0, 0.85) !important;\n}\n.ant-tooltip-arrow {\n  display: none !important;\n}\n.ant-tooltip-placement-right {\n  padding-left: 0 !important;\n}\n.formItem {\n  margin-bottom: 25px !important;\n  margin-left: 0 !important;\n}\n.customPhoneNumber .ant-input-group-addon {\n  height: 44px;\n  border: 0;\n  background: #fff;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.customPhoneNumber .ant-input {\n  height: 44px;\n  border: 0;\n  background: #fff;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.sideFixed {\n  position: fixed !important;\n  width: 100%;\n  right: 0;\n}\n.sellerFormDes {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: calc(83vh - 0px);\n  justify-content: space-between;\n}\n\n/***** Custom Table *****/\n.stateCustomTable .ant-table {\n  border-top-left-radius: 16px !important;\n  border-top-right-radius: 16px !important;\n}\n.stateCustomTable table thead .ant-table-cell,\n.lotCustomTable thead tr .ant-table-cell {\n  background: #ef790d !important;\n  color: #fff !important;\n  text-transform: uppercase;\n  font-weight: 500 !important;\n  padding: 10px;\n}\n.stateCustomTable table tbody .ant-table-cell {\n  padding: 10px !important;\n  font-weight: 500;\n}\n.textCenter table tbody .ant-table-cell,\n.textCenter table thead .ant-table-cell {\n  text-align: center;\n  padding: 13px !important;\n  font-weight: 500;\n  font-size: 12px;\n}\ntable tbody .ant-table-cell,\ntable thead .ant-table-cell {\n  font-size: 12px;\n}\n.stateCustomTable table thead .ant-table-cell,\n.stateCustomTable table tbody .ant-table-cell {\n  text-align: center;\n}\n.stateCustomTable table thead .ant-table-cell::before {\n  display: none !important;\n}\n.stateCustomTable .ant-pagination,\n.reportCustomtable .ant-pagination {\n  background: #fff !important;\n  margin: 0 !important;\n  padding: 10px 50px !important;\n  justify-content: end !important;\n  border-bottom-left-radius: 14px !important;\n  border-bottom-right-radius: 14px !important;\n}\n.stateCustomTable\n  .ant-pagination\n  .ant-pagination-prev\n  .ant-pagination-item-link,\n.reportCustomtable\n  .ant-pagination\n  .ant-pagination-prev\n  .ant-pagination-item-link,\n.stateCustomTable\n  .ant-pagination\n  .ant-pagination-next\n  .ant-pagination-item-link,\n.reportCustomtable\n  .ant-pagination\n  .ant-pagination-next\n  .ant-pagination-item-link {\n  background-color: transparent !important;\n  color: #bcbcbc !important;\n  font-size: 14px !important;\n  line-height: 14px !important;\n  border: 0 !important;\n}\n.stateCustomTable .ant-pagination .ant-pagination-item-active,\n.reportCustomtable .ant-pagination .ant-pagination-item-active {\n  border-color: #fff !important;\n  border-radius: 50% !important;\n  background-color: #f3f3f3 !important;\n  color: #707070 !important;\n}\n.stateCustomTable table > thead > tr:first-child th:first-child {\n  border-top-left-radius: 14px !important;\n}\n.stateCustomTable table > thead > tr:last-child th:last-child {\n  border-top-right-radius: 14px !important;\n}\n.stateCustomTable table > tbody > tr:nth-child(even) {\n  background-color: #f9f9f9 !important;\n}\n.stateCustomTable .ant-table-column-sorters,\n.reportCustomtable .ant-table-column-sorters {\n  justify-content: center !important;\n}\n.stateCustomTable .ant-table-column-title,\n.reportCustomtable .ant-table-column-title {\n  flex: initial !important;\n}\n.stateCustomTable .ant-table-column-sorter,\n.reportCustomtable .ant-table-column-sorter {\n  color: #fff !important;\n  margin-left: 10px;\n}\n.stateCustomTable .anticon {\n  font-size: 14px;\n  color: #fff !important;\n  /* margin-right: 10px; */\n}\n.stateCustomTable\n  table\n  tbody\n  .ant-table-expanded-row\n  .ant-table-cell\n  table\n  thead\n  .ant-table-cell {\n  background: #ededed !important;\n  color: inherit !important;\n  text-transform: inherit;\n  font-weight: inherit !important;\n}\n.nastedTable table > thead > tr:first-child th:first-child,\n.nastedTable table > thead > tr:last-child th:last-child {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n.nastedTable table thead .ant-table-cell,\n.nastedTable table tbody .ant-table-cell {\n  text-align: center;\n}\n.reportCustomtable table thead .ant-table-cell {\n  background: #954c0a !important;\n  color: #fff !important;\n  text-transform: uppercase;\n  font-weight: 500 !important;\n  padding: 10px !important;\n}\n.stateCustomTable\n  .ant-pagination\n  .ant-pagination-prev\n  .ant-pagination-item-link,\n.stateCustomTable\n  .ant-pagination\n  .ant-pagination-next\n  .ant-pagination-item-link,\n.deltaTable .ant-pagination .ant-pagination-prev .ant-pagination-item-link,\n.deltaTable .ant-pagination .ant-pagination-next .ant-pagination-item-link {\n  background-color: transparent !important;\n  color: #000 !important;\n  font-size: 16px !important;\n  line-height: 16px !important;\n}\n.stateCustomTable .ant-pagination .ant-pagination-item,\n.deltaTable .ant-pagination .ant-pagination-item {\n  border-color: #fff !important;\n  border-radius: 50% !important;\n}\n.stateCustomTable .ant-pagination .ant-pagination-item-active,\n.deltaTable .ant-pagination .ant-pagination-item-active {\n  border-color: #ef790c !important;\n  background: #ef790c !important;\n  color: #fff !important;\n}\n.stateCustomTable .ant-pagination,\n.deltaTable .ant-pagination {\n  background: #dcdcdc !important;\n  margin: 0 !important;\n  padding: 16px 0 !important;\n  justify-content: center !important;\n  border-bottom-left-radius: 14px !important;\n  border-bottom-right-radius: 14px !important;\n}\n.greenBoxs {\n  display: flex;\n  justify-content: end;\n}\n.greenBoxs .innerGreenBox {\n  width: 130px;\n  text-align: center;\n  background: #22b253;\n  margin-left: 2px;\n}\n.greenBoxs .innerGreenBox p {\n  margin-bottom: 0;\n  color: #fff;\n}\n.greenBoxs .innerGreenBox .boxDesc {\n  font-size: 18px;\n  font-weight: 600;\n}\n.math {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.invoiceBtn {\n  background: transparent !important;\n  border: 0 !important;\n  color: #707070 !important;\n  font-size: 16px !important;\n  box-shadow: none !important;\n}\n.invoiceBtn:hover {\n  background: transparent;\n  color: #954c0a !important;\n}\n/***** Filter Section *****/\n.filterSection {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n.customSearch .ant-input-group .ant-input-group-addon {\n  box-shadow: none !important;\n  border-top-right-radius: 25px;\n  border-bottom-right-radius: 25px;\n}\n.customSearch .ant-input-group .ant-input-group-addon .ant-input-search-button {\n  background: #22b253 !important;\n  border-color: #22b253 !important;\n  box-shadow: none !important;\n  padding: 5px 10px;\n  border-top-right-radius: 25px !important;\n  border-bottom-right-radius: 25px !important;\n}\n.customInput .ant-select-selector,\n.customInput .ant-input-affix-wrapper {\n  border: 0 !important;\n  height: 32px;\n  font-size: 12px !important;\n  border-radius: 25px !important;\n  font-weight: 500;\n}\n/* .font-md .ant-select-selector, .font-md .ant-input-affix-wrapper {\n  font-size: 14px !important;\n  font-weight: 500;\n} */\n.ant-select-dropdown {\n  padding: 0 !important;\n}\n.ant-select-dropdown .ant-select-item {\n  font-size: 12px;\n  padding: 8px !important;\n  border-bottom: 1px solid #f3f3f3;\n}\n/***** FormModal *****/\n.ant-popover .ant-popover-content .ant-popover-inner {\n  border-radius: 6px !important;\n  -webkit-box-shadow: 0px 0px 6px 5px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0px 0px 6px 5px rgba(0, 0, 0, 0.1);\n  box-shadow: 0px 0px 6px 5px rgba(0, 0, 0, 0.1);\n}\n.ant-popover\n  .ant-popover-content\n  .ant-popover-inner\n  .ant-popover-inner-content {\n  padding: 0;\n}\n.editFormProduct .ant-form-item {\n  padding: 5px 20px;\n  border-bottom: 1px solid #f3f3f3;\n  margin-bottom: 5px;\n}\n.editFormProduct .ant-form-item:first-child {\n  padding: 15px 15px 0 15px;\n}\n.editFormProduct .ant-form-item:last-child {\n  padding: 15px 25px;\n  text-align: end;\n}\n.editFormProduct .ant-form-item .ant-form-item-label {\n  padding-bottom: 0 !important;\n}\n.editFormProduct .ant-form-item .ant-form-item-control-input {\n  min-height: 0 !important;\n}\n.editFormProduct .ant-form-item .ant-form-item-control-input input {\n  font-size: 12px;\n  border: 0;\n  padding: 0;\n}\n.editFormProduct .ant-form-item .ant-form-item-label label {\n  color: #bcbcbc;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.dragBox .ant-upload-drag {\n  border: 2px dashed #bcbcbc !important;\n  border-radius: 6px !important;\n  padding: 10px;\n}\n.dragBox .ant-form-item-control-input-content > p + span {\n  display: flex;\n  justify-content: space-between;\n}\n/* .dragBox .ant-form-item-control-input-content > p + span .ant-upload-drag,\n.dragBox .ant-form-item-control-input-content > p + span .ant-upload-list-text {\n  width: 50%;\n  padding: 0 15px;\n} */\n.dragBox .ant-upload.ant-upload-drag p.ant-upload-text {\n  font-size: 14px;\n}\n.infoTexts {\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n}\n.infoTexts .anticon {\n  font-size: 24px;\n  color: #bcbcbc;\n  margin-right: 10px;\n}\n.divider {\n  width: 100%;\n  height: 1px;\n  background: #f6851f;\n  margin: 10px 0;\n}\n.underLogoText {\n  margin-bottom: 0;\n  font-size: 20px;\n  font-weight: 500;\n}\n.prefixImg .ant-form-item-control-input-content {\n  display: flex;\n  align-items: center;\n  border: 1px solid #e4e4e4 !important;\n  border-radius: 6px !important;\n  height: 50px !important;\n  padding: 10px 20px !important;\n  background-color: #fff;\n}\ninput:focus {\n  box-shadow: none !important;\n  outline: 0 !important;\n  border-color: transparent !important;\n}\n\n.colAfter::after {\n  position: absolute;\n  content: \">\";\n  font-size: 26px;\n  color: #22b253;\n  top: 30%;\n  right: -7px;\n  bottom: 0;\n}\n.tableInput {\n  display: flex;\n  flex-direction: column;\n  /* justify-content: space-between;\n  align-items: center; */\n}\n/***** Warehouse Modal *****/\n.warehouseModal .ant-modal-content {\n  border-radius: 20px;\n}\n.warehouseModal .ant-modal-content .ant-modal-header {\n  background: #954c0a;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n.warehouseModal .ant-modal-content .ant-modal-header .ant-modal-title {\n  color: #fff;\n}\n.warehouseModal .ant-modal-content .ant-modal-close {\n  background: #fff;\n  top: 10px;\n  right: 10px;\n  border-radius: 10px;\n}\n.warehouseModal .ant-modal-content .ant-modal-close .ant-modal-close-x {\n  width: 30px;\n  height: 30px;\n  line-height: 24px;\n}\n.warehouseModal .ant-modal-body p {\n  font-size: 14px;\n  font-weight: 500;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.warehouseModal .ant-modal-body p:last-child {\n  border-bottom: none;\n}\n.valueImage {\n  width: 60px;\n  height: 60px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n/**** Profile Dropdown *****/\n.profileDropdownMenu {\n  padding: 0 !important;\n}\n.profileDropdownMenu .ant-dropdown-menu-item {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e9e9e9;\n  color: #000 !important;\n  font-weight: 500;\n}\n.profileDropdownMenu .ant-dropdown-menu-item .dropMenuIcon {\n  margin-right: 10px;\n  color: #954c0a;\n  font-size: 16px;\n  vertical-align: text-top;\n}\n.editButton {\n  font-size: 16px;\n  color: #707070 !important;\n  font-weight: 500;\n}\n.editButton:hover {\n  color: #954c0a !important;\n}\n.absltBtn {\n  position: absolute !important;\n  width: auto !important;\n  color: #fff !important;\n  top: 1.5rem;\n}\n.absltBtn span {\n  font-size: 14px;\n}\n\n.deltaTableHeader {\n  width: 100%;\n  padding: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ef790c;\n  border-top-left-radius: 16px !important;\n  border-top-right-radius: 16px !important;\n}\n.deltaTableHeader .innerGreenBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #fff;\n  margin-right: 10px;\n  padding: 10px 15px;\n  cursor: pointer;\n}\n.deltaTableHeader .innerGreenBox .boxHeading {\n  margin-right: 15px;\n}\n.deltaTableHeader .innerGreenBox .boxHeading,\n.deltaTableHeader .innerGreenBox .boxDesc {\n  font-size: 16px;\n  color: #707070;\n  margin-bottom: 0px;\n  text-transform: uppercase;\n}\n.sllrPrdctBtn {\n  top: 1.2rem;\n  right: 19rem;\n}\n/***** Responsive Style *****/\n@media (max-width: 280px) {\n  .signInPage .SignInFormSection .customCard .ant-card-body {\n    padding: 14px 24px;\n  }\n}\n@media (max-width: 767px) {\n  .mobHide {\n    display: none !important;\n  }\n  .signInPage .SignInFormSection .customCard {\n    width: 100%;\n  }\n  .sellerRegistration .formSection .formBody {\n    padding-left: 0;\n  }\n  .mobCenter {\n    margin: 0 auto;\n  }\n  .sideFixed {\n    display: none;\n  }\n  .formSections {\n    padding-bottom: 50px;\n  }\n  .sidebar,\n  .sidebar.open {\n    display: none;\n  }\n  .home-section,\n  .sidebar.open ~ .home-section {\n    width: 100%;\n    left: 0;\n  }\n  .mobSider .sidebar,\n  .mobSider .sidebar.open {\n    display: block;\n    width: auto;\n  }\n  .mobSider .ant-drawer-content-wrapper {\n    width: 80% !important;\n  }\n  .mobSider .ant-drawer-body {\n    padding: 10px !important;\n  }\n  .mobSider.ant-drawer .ant-drawer-content {\n    background: #d18146;\n  }\n  .mobSider .nav-list {\n    /* margin-top: 20px; */\n    height: 100%;\n    padding-left: 0;\n    background: transparent;\n  }\n  .mobSider ul li .menuImg {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    border-radius: 50%;\n    background-color: #fff;\n    text-align: center;\n  }\n  .mobSider li {\n    position: relative !important;\n    margin: 15px 8px !important;\n    list-style: none;\n  }\n  .mobSider li a {\n    display: flex;\n    height: 100%;\n    width: 100%;\n    padding: 8px;\n    border-radius: 6px;\n    align-items: center;\n    text-decoration: none;\n    transition: 0.2s linear;\n    -webkit-transition: 0.2s linear;\n    -moz-transition: 0.2s linear;\n    -ms-transition: 0.2s linear;\n    -o-transition: 0.2s linear;\n  }\n  .table-responsive .ant-table-content {\n    overflow-x: auto;\n  }\n  .tabDirection,\n  .filterSection {\n    flex-direction: column;\n  }\n  .filterSection .customInput {\n    width: 100% !important;\n    margin-bottom: 15px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .signInPage .SignInFormSection .customCard {\n    width: 100%;\n  }\n  .signInPage .SignInFormSection .customCard .ant-card-body {\n    padding: 25px;\n  }\n  .sidebar,\n  .sidebar.open {\n    display: none;\n  }\n  .home-section,\n  .sidebar.open ~ .home-section {\n    width: 100%;\n    left: 0;\n  }\n  .mobSider .sidebar,\n  .mobSider .sidebar.open {\n    display: block;\n    width: auto;\n  }\n  .mobSider .ant-drawer-content-wrapper {\n    width: 50% !important;\n  }\n  .mobSider .ant-drawer-body {\n    padding: 10px !important;\n  }\n  .mobSider.ant-drawer .ant-drawer-content {\n    background: #d18146;\n  }\n  .mobSider .nav-list {\n    /* margin-top: 20px; */\n    height: 100%;\n    padding-left: 0;\n    background: transparent;\n  }\n  .mobSider ul li .menuImg {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    border-radius: 50%;\n    background-color: #fff;\n    text-align: center;\n  }\n  .mobSider li {\n    position: relative !important;\n    margin: 15px 8px !important;\n    list-style: none;\n  }\n  .mobSider li a {\n    display: flex;\n    height: 100%;\n    width: 100%;\n    padding: 8px;\n    border-radius: 6px;\n    align-items: center;\n    text-decoration: none;\n    transition: 0.2s linear;\n    -webkit-transition: 0.2s linear;\n    -moz-transition: 0.2s linear;\n    -ms-transition: 0.2s linear;\n    -o-transition: 0.2s linear;\n  }\n  .table-responsive .ant-table-content {\n    overflow-x: auto;\n  }\n  .tabDirection {\n    flex-direction: column;\n  }\n  .sellerRegistration .formSection .formBody {\n    padding: 30px 0 0px 20px;\n  }\n}\n@media only screen and (min-width: 64.063em) {\n  /* .marTp {\n    margin-top: 10%;\n  } */\n}\n@media only screen and (min-width: 1400px) and (max-width: 2560px) {\n  .lg-mb {\n    margin-top: 22px !important;\n  }\n}\n\n.ant-result {\n  align-self: center;\n}\n\nbody,\n#root {\n  height: 100%;\n}\n\n.errorPageBody {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
